import React from "react";
import { createPortal } from "react-dom";
import { Drawer, Typography, Box, IconButton } from "@mui/material";
import { DrawerContext } from "./DrawerContext";
import MotionClose from "../../Icons/MotionClose";

const EMPDrawer = () => {
  const {
    drawerHeading,
    drawerContent,
    handleDrawer,
    openDrawer,
    drawerRef,
    drawerAnchor,
  } = React.useContext(DrawerContext);
  return createPortal(
    <Drawer
      ref={drawerRef}
      anchor={drawerAnchor}
      open={openDrawer}
      onClose={() => handleDrawer(false, false)}
      sx={{
        "& .MuiDrawer-paper": {
          width: 390,
          minWidth: 320,
          padding: 4,
          height: "100vh",
          overflow: "hidden",
        },
      }}
    >
      <Box textAlign="right">
        <IconButton
          onClick={() => handleDrawer(false, false)}
          data-testid="drawer-close-button"
        >
          <MotionClose />
        </IconButton>
      </Box>
      <Box
        role="presentation"
        sx={{
          overflowY: "auto",
          paddingBottom: 4,
          maxHeight: "calc(100vh - 64px)",
        }}
      >
        <Typography variant="h4" sx={{ mb: 6 }}>
          {drawerHeading}
        </Typography>
        {drawerContent}
      </Box>
    </Drawer>,
    document.querySelector("#drawer-root")
  );
};

export default EMPDrawer;
